import { BaseModel } from './base-model.interface';
import BlockModel from './block-model.interface';
import { NotificationInitVariables } from '../template/notifications-model.interface';
import { EventInitVariables } from './event.interface';

export interface DisclaimerModel extends BaseModel {
  variables?: { [key: string]: string } | DisclaimerVariables;
}

export interface DisclaimerVariables {
  Disclaimer: string;
}

export class DisclaimerInitVariables implements DisclaimerVariables {
  Disclaimer = '';
}

export class DisclaimerInitModel implements BlockModel {
  blockId: string = '';
  count: number = 0;
  name: string = '';
  variables: { [key: string]: string };
  notifications: NotificationInitVariables[];

  constructor() {
    const initVars = new DisclaimerInitVariables();
    this.variables = {...initVars};
    this.notifications = [new NotificationInitVariables()];
  }
}
